import clsx from 'clsx';
import styled from 'styled-components';

import Button from '@hotmart/space-lib/dist/components/button';
import type { ToggleProps } from './types';

const Container = styled.div`
  .buttonSelected {
    background-color: var(--gray-900) !important;
    color: var(--gray-100) !important;

    &:hover {
      background-color: var(--gray-900) !important;
    }

    &:focus {
      background-color: var(--gray-900) !important;
    }
  }
`;

Container.displayName = 'Container';

const Notify = styled.span`
  width: 0.563rem;
  height: 0.563rem;
`;

Notify.displayName = 'Notify';

const Toggles = ({
  name,
  hasNewNotification,
  handleClick,
  isActive,
  disabled,
  loading
}: ToggleProps) => {
  return (
    <Container>
      <Button
        variation="default"
        className={clsx('_rounded-pill', {
          buttonSelected: isActive && !disabled && !loading
        })}
        data-test="toggle-filter"
        disabled={disabled}
        loading={loading}
        onClick={handleClick}
      >
        {name}
        {hasNewNotification && (
          <Notify
            data-test="notify"
            className="_bg-red _d-inline-flex _align-items-center _ml-1 _rounded-circle"
          />
        )}
      </Button>
    </Container>
  );
};

export default Toggles;
